import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import 'dayjs/locale/fi' // import the locale you want to use
import React from 'react'
import { createRoot } from 'react-dom/client'
import { I18nextProvider } from 'react-i18next'
import App from './App'
import ErrorBoundary from './components/ErrorBoundary'
import AppContextProvider from './contexts/AppContext'
import ConsumptionDataContextProvider from './contexts/ConsumptionDataContext'
import ModalContextProvider from './contexts/ModalContext'
import ObjectContextProvider from './contexts/objectContext/ObjectContext'
import UserContextProvider from './contexts/UserContext'
import i18n from './i18n'
import { trpc, trpcClient } from './modules/trpc'
import * as serviceWorker from './serviceWorker'

const queryClient = new QueryClient()

const trpcReactClient = trpc.createClient({
	links: [trpcClient],
})

const container = document.getElementById('root')
if (!container) throw new Error('Root container not found')

const root = createRoot(container)

root.render(
	<trpc.Provider client={trpcReactClient} queryClient={queryClient}>
		<QueryClientProvider client={queryClient}>
			<AppContextProvider>
				<ModalContextProvider>
					<UserContextProvider>
						<I18nextProvider i18n={i18n}>
							<ObjectContextProvider>
								<ConsumptionDataContextProvider>
									<ErrorBoundary>
										<App />
									</ErrorBoundary>
								</ConsumptionDataContextProvider>
							</ObjectContextProvider>
						</I18nextProvider>
					</UserContextProvider>
				</ModalContextProvider>
			</AppContextProvider>
		</QueryClientProvider>
	</trpc.Provider>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
